/**
 * Response shapes for GET /api/projects/filter_options and GET /api/resources/filter_options (camelCase).
 */
export interface ProjectFilterOptions {
  status: string[]
  conventionAvailable: boolean[]
  attributionInstance: string[]
  economicNature: string[]
  fundingYear: number[]
  fundingAmount: number[]
  sector: string[]
  fundingType: string[]
}

export interface ResourceFilterOptions {
  type: string[]
  administrativeScopes: string[]
  thematics: string[]
}

export function createEmptyProjectFilterOptions(): ProjectFilterOptions {
  return {
    status: [],
    conventionAvailable: [],
    attributionInstance: [],
    economicNature: [],
    fundingYear: [],
    fundingAmount: [],
    sector: [],
    fundingType: [],
  }
}

export function createEmptyResourceFilterOptions(): ResourceFilterOptions {
  return {
    type: [],
    administrativeScopes: [],
    thematics: [],
  }
}
